<template>
  <div class="ui-header-dropdown-menu component">
    
  </div>
</template>

<script>
import UiBaseMenuDropdown from './UiBaseMenuDropdown'

export default {
  name: 'UiHeaderDropdownMenu',
  components: { UiBaseMenuDropdown }
}
</script>
